import { makeAutoObservable, toJS } from "mobx";
import axios from "axios";

class DistrictData {
  //global data
  districts: [];
  allChecked: true;
  showAdministrativeDivisions = false;
  ArrayDistrictsLayers = [
    { id: 1, url: "kml/admir.kml" },
    { id: 2, url: "kml/vas.kml" },
    { id: 3, url: "kml/viborg.kml" },
    { id: 4, url: "kml/kalin.kml" },
    { id: 5, url: "kml/kirov.kml" },
    { id: 6, url: "kml/kolpin.kml" },
    { id: 7, url: "kml/krasnogvard.kml" },
    { id: 8, url: "kml/krasnoSelsk.kml" },
    { id: 9, url: "kml/kronshtad.kml" },
    { id: 10, url: "kml/kyrortn.kml" },
    { id: 11, url: "kml/moskovkiy.kml" },
    { id: 12, url: "kml/nevskiy.kml" },
    { id: 13, url: "kml/petrograd.kml" },
    { id: 14, url: "kml/petroDvor.kml" },
    { id: 15, url: "kml/promorskiy.kml" },
    { id: 16, url: "kml/pyshkin.kml" },
    { id: 17, url: "kml/frynzec.kml" },
    { id: 18, url: "kml/central.kml" },
    //{ id: 19, url: "kml/gatchin.kml" },
  ];
  ArrayDistrictsLayersData = [
    { id: 1, url: "kml/admir.kml" },
    { id: 2, url: "kml/vas.kml" },
    { id: 3, url: "kml/viborg.kml" },
    { id: 4, url: "kml/kalin.kml" },
    { id: 5, url: "kml/kirov.kml" },
    { id: 6, url: "kml/kolpin.kml" },
    { id: 7, url: "kml/krasnogvard.kml" },
    { id: 8, url: "kml/krasnoSelsk.kml" },
    { id: 9, url: "kml/kronshtad.kml" },
    { id: 10, url: "kml/kyrortn.kml" },
    { id: 11, url: "kml/moskovkiy.kml" },
    { id: 12, url: "kml/nevskiy.kml" },
    { id: 13, url: "kml/petrograd.kml" },
    { id: 14, url: "kml/petroDvor.kml" },
    { id: 15, url: "kml/promorskiy.kml" },
    { id: 16, url: "kml/pyshkin.kml" },
    { id: 17, url: "kml/frynzec.kml" },
    { id: 18, url: "kml/central.kml" },
    //{ id: 19, url: "kml/gatchin.kml" },
  ];

  constructor() {
    makeAutoObservable(this, {}, { deep: true });
  }

  //actions
  getDistricts() {
    axios
      .get(`/Nsi/Districts`, {})
      .then((res) => {
        this.districts = res.data.items.filter(x => x.externalId > 0);
      })
      .catch(console.log);
  }

  districtsLayer(e) {
    this.ArrayDistrictsLayers = e
      ? [
          { id: 1, url: "kml/admir.kml" },
          { id: 2, url: "kml/vas.kml" },
          { id: 3, url: "kml/viborg.kml" },
          { id: 4, url: "kml/kalin.kml" },
          { id: 5, url: "kml/kirov.kml" },
          { id: 6, url: "kml/kolpin.kml" },
          { id: 7, url: "kml/krasnogvard.kml" },
          { id: 8, url: "kml/krasnoSelsk.kml" },
          { id: 9, url: "kml/kronshtad.kml" },
          { id: 10, url: "kml/kyrortn.kml" },
          { id: 11, url: "kml/moskovkiy.kml" },
          { id: 12, url: "kml/nevskiy.kml" },
          { id: 13, url: "kml/petrograd.kml" },
          { id: 14, url: "kml/petroDvor.kml" },
          { id: 15, url: "kml/promorskiy.kml" },
          { id: 16, url: "kml/pyshkin.kml" },
          { id: 17, url: "kml/frynzec.kml" },
          { id: 18, url: "kml/central.kml" },
          //{ id: 19, url: "kml/gatchin.kml" },
        ]
      : [];
  }

  setLayers(districtId, e) {
    if (!e) {
      this.ArrayDistrictsLayers = this.ArrayDistrictsLayers.filter(
        (item) => item.id !== districtId,
      );
    } else {
      this.ArrayDistrictsLayers.push(
        this.ArrayDistrictsLayersData[districtId - 1],
      );
    }
    console.log(toJS(this.ArrayDistrictsLayers));
  }
}
export default new DistrictData();
